import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";

export default function Register() {
  const { t } = useLang();
  const { register } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await register(form); nav(params.get("redirect") || "/portal"); }
    catch (e) { toast.error(e.response?.data?.detail || t({ en: "Registration failed", fr: "Échec de l'inscription" })); }
    finally { setLoading(false); }
  };
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="max-w-md mx-auto px-4 py-16 lg:py-24" data-testid="register-page">
      <div className="overline mb-4">{t({ en: "Create account", fr: "Créer un compte" })}</div>
      <h1 className="font-serif text-4xl mb-8 tracking-tight" style={{ color: "var(--ink)" }}>{t({ en: "Welcome.", fr: "Bienvenue." })}</h1>
      <form onSubmit={submit} className="space-y-4">
        <FieldR label={t({ en: "Name", fr: "Nom" })} value={form.name} onChange={upd("name")} required testid="reg-name" />
        <FieldR label={t({ en: "Email", fr: "Courriel" })} type="email" value={form.email} onChange={upd("email")} required testid="reg-email" />
        <FieldR label={t({ en: "Phone (optional)", fr: "Téléphone (facultatif)" })} value={form.phone} onChange={upd("phone")} testid="reg-phone" />
        <FieldR label={t({ en: "Password (6+ chars)", fr: "Mot de passe (6+ car.)" })} type="password" value={form.password} onChange={upd("password")} required testid="reg-password" />
        <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="btn-register">
          {loading ? t({ en: "Creating account…", fr: "Création du compte…" }) : t({ en: "Create account", fr: "Créer le compte" })}
        </button>
      </form>
      <p className="mt-6 text-sm" style={{ color: "var(--ink-2)" }}>{t({ en: "Already have an account?", fr: "Vous avez déjà un compte?" })} <Link to={`/login${params.get("redirect") ? `?redirect=${params.get("redirect")}` : ""}`} className="link-underline">{t({ en: "Sign in", fr: "Se connecter" })}</Link></p>
    </div>
  );
}

function FieldR({ label, testid, ...props }) {
  return (
    <div>
      <label className="overline mb-2 block">{label}</label>
      <input {...props} className="w-full p-3 rounded-lg border" style={{ borderColor: "var(--border-medium)", background: "var(--surface)" }} data-testid={testid} />
    </div>
  );
}
